import i18n from '@/utils/i18n';
import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
import app from './modules/app'
import permission from './modules/permission'
import settings from './modules/settings'
import user from './modules/user'
import enumerate from './modules/enumerate'
import activity from './modules/activity'
import hardware from './modules/hardware'
import calendar from './modules/calendar'
import datakanban from './modules/datakanban'
import options from './modules/options'
import member from './modules/member'
import dialingCode from './modules/dialingCode'
Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    app,
    permission,
    settings,
    user,
    enumerate,
    activity,
    hardware,
    calendar,
    options,
    datakanban,
    member,
    dialingCode
  },
  getters
})

export default store
